import { render } from "./PromotionStatus.vue?vue&type=template&id=69e7c19c&scoped=true"
import script from "./PromotionStatus.vue?vue&type=script&lang=js"
export * from "./PromotionStatus.vue?vue&type=script&lang=js"

import "./PromotionStatus.vue?vue&type=style&index=0&id=69e7c19c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e7c19c"]])

export default __exports__